'use strict';

exports.__esModule = true;
exports.default = {
  LIKE: 'like',
  RECOMMEND: 'recommend'
};
//# sourceMappingURL=LikeAction.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/LikeAction.js
// module id = 1236
// module chunks = 198517197184460